import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import React, { useEffect, useRef, useState } from "react";
import SearchIcon from "@mui/icons-material/Search";

import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
// import { DatePicker } from '@mui/x-date-pickers/DatePicker';

import EventIcon from "@mui/icons-material/Event";

import {
  Box,
  Button,
  Divider,
  Fab,
  Grid,
  IconButton,
  InputAdornment,
  Pagination,
  Tab,
  Tabs,
  TextField,
  Typography,
} from "@mui/material";
import {
  getAccountReachageDetails,
  getAllAppoint,
} from "./appoinmentDashboardApi";
import SmbAccountReachargeCard from "./AppoinmentDashboardCard";
import AddIcon from "@mui/icons-material/Add";
import DisplayAnnualRecharge from "./displayAnnualRecharge";
import { getData } from "./smbAccountRechargeCustomApiHandler";

import {
  convertDateToCustomFormat,
  getFirstDateOfMonth,
  getStartOfMonth,
} from "../../utils/commonUtils";
import AppoinmentDashboardCard from "./AppoinmentDashboardCard";
import DatePickerComponent from "../../common/curstomDatePicker";
import Appoinmentadle from "../appoinmentModal/appoinmentModal";
import { UpdatedCustomerAppointment } from "../appoinmentModal/appoinmentModalApi";
import EmployeePayRollModal from "../employeePayRoll/employeeModal";
import EmployeeModal from "../../common/employeeModel";
import { PaginationCm } from "../../common/pagination";
import DynamicBreadcrumbs from "../../common/Breadcrumb";
import { useSelector } from "react-redux";
import { useTheme } from "@emotion/react";
import CalendarComponent from "./calenderPop";
import CalenderModal from "./calenderModal";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import AppointmentDashboardCard from "./AppointmentDashboardCard";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import calendar from "../../assets/icon/calendarblack.png";

export default function AppoinmentDashboard() {
  const [openCalender, setOpenCalender] = useState(false);
  const [pagination, setPagination] = useState({
    page: 1,
    pageSize: 1000,
    total: 1,
  });
  const [initialFormattedDate, setinitialFormattedDate] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [searchOutStandingsModal, setSearchOutStandingsModal] = useState(false);

  const [openT, aetOpenT] = useState(false);
  const datePickerRef = useRef();
  const openDatePicker = () => {
    if (datePickerRef.current) {
      datePickerRef.current.setOpen(true);
    }
  };
  const [search, setSearch] = useState("");

  const [date, setDate] = useState(getStartOfMonth());
  const [open, setOpen] = useState(false);

  const [SelectedStartDate, setSelectedStartDate] = useState(
    getFirstDateOfMonth()
  );

  const theme = useTheme();

  const [modalData, setModalData] = useState();
  const [selectedCustomer, setSelectedCustomer] = useState(null);

  const [value, setValue] = React.useState("Unassigned");
  const [data, setData] = useState();
  const [valuet, setValuet] = React.useState("Assigned");

  const handleChange = (event, newValue) => {
    // setPageNo(1);

    setValue(newValue);
  };
  const handleChanget = (event, newValue) => {
    // setPageNo(1);

    setValuet(newValue);
  };

  useEffect(() => {
    getAllAppoint(
      { page: pagination.page, pageSize: pagination.pageSize },
      (res) => {
        console.log("getAllAppoint", res);
        setData(res?.list);
        setPagination({ ...pagination, total: res?.totalRecords });
      }
    );
    // getData(getAccountReachageDetails, setData);
  }, []);
  const businessChooseTab = useSelector(
    (state) => state.reducer.businessChooseTab
  );

  useEffect(() => {
    if (open == false) {
      setSelectedCustomer(null);
    }
  }, [open]);
  const [selectedDate, setSelectedDate] = React.useState();
  const [isDatePickerOpen, setIsDatePickerOpen] = React.useState(false);

  const handleOpenDatePicker = () => {
    setIsDatePickerOpen(true);
  };

  const handleCloseDatePicker = () => {
    setIsDatePickerOpen(false);
  };
  useEffect(() => {
    console.log("selectedCustomer", selectedCustomer);
  }, [selectedCustomer]);

  useEffect(() => {
    // const inputDate = selectedDate;
    // const date = new Date(inputDate);
    // const formattedDate = date.toISOString().split("T")[0];

    getAllAppoint(
      {
        page: 1,
        pageSize: 1000,
        search: dayjs(selectedDate).format("YYYY-MM-DD"),
        filter: "date",
      },
      (res) => {
        console.log("getAllAppoint", res);
        setData(res?.list);
      }
    );
  }, [selectedDate]);
  useEffect(() => {
    if (businessChooseTab?.value) {
      setValue(businessChooseTab?.value);
    }
    setSearch("");
    setSelectedCustomer(null);
  }, [businessChooseTab?.value, valuet]);

  return (
    <>
      {/* <DynamicBreadcrumbs /> */}
      <Grid
        px={{ sm: 2, xs: 2, md: 4 }}
        pb={4}
        container
        sx={{
          paddingTop: "15px",
          backgroundColor: "#E3E3FF",
          fontFamily: "'Montserrat', sans-serif",
        }}
      >
        <Grid
          item
          xs={10}
          sx={{
            background:
              "linear-gradient(264deg, rgba(215, 215, 255, 0) 0%, rgba(155, 155, 243, 1) 100%)",
            padding: "10px 15px",
            mt: "10px",
            borderRadius: "5px",
            color: "#01008B", // optional text color
            textAlign: "left",
            marginBottom: "20px",
            fontFamily: "'Montserrat', sans-serif",
            fontSize: "20px",
            fontWeight: 500,
          }}
        >
          <Typography
            variant="h6"
            fontSize={{ xs: "12px", sm: "13px", md: "17px" }}
          >
            {value === "Unassigned" ? "Unassigned" : "Assigned"} Appointments
          </Typography>
        </Grid>
        <Grid
          item
          xs={2}
          sx={{
            display: "flex",
            justifyContent: "end",
            alignItems: "center",
          }}
        >
          <CalendarMonthIcon
            sx={{
              cursor: "pointer",
              fontSize: { xs: "15px", sm: "18px", md: "35px" },

              color: "secondary.main",
              backgroundColor: "#010093",
              padding: "10px 12px",
              color: "white",
              borderRadius: "10px",
            }}
            onClick={() => {
              setOpenCalender(true);
            }}
          />
        </Grid>

        {businessChooseTab?.value === "Unassigned" && (
          <Grid item xs={12}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={8}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    value={selectedDate ? dayjs(selectedDate) : null}
                    onChange={(newValue) => {
                      setSelectedDate(newValue);
                    }}
                    format="DD-MMM-YYYY"
                    slots={{ openPickerIcon: CalendarMonthIcon }}
                    slotProps={{
                      textField: {
                        fullWidth: true,
                        size: "small",
                        label: "Date",
                        InputLabelProps: {
                          sx: {
                            background: "#fff",
                            borderRadius: 1,
                            fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          },
                        },
                        InputProps: {
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton edge="end">
                                <Box
                                  component="img"
                                  src={calendar}
                                  alt="calendar icon"
                                  sx={{
                                    width: 20,
                                    height: 20,
                                    cursor: "pointer",
                                  }}
                                />
                              </IconButton>
                            </InputAdornment>
                          ),
                          sx: {
                            "& input": {
                              fontSize: { xs: "12px", sm: "13px", md: "15px" },
                              fontFamily: "Montserrat",
                              fontWeight: 500,
                            },
                            "& label": {
                              fontSize: { xs: "12px", sm: "13px", md: "15px" },
                            },
                            background: "#fff",
                            // fontSize: { xs: "12px", sm: "13px", md: "20px" },
                            borderRadius: 1,
                            "& fieldset": { border: "none" },
                          },
                        },
                      },

                      openPickerIcon: {
                        sx: { color: "#000" },
                      },
                    }}
                    InputLabelProps={{
                      className: "mulish",
                      sx: {
                        color: "#545454",
                        fontWeight: 400,
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        paddingX: "7px",
                      },
                    }}
                  />
                </LocalizationProvider>
              </Grid>
              <Grid
                item
                md={4}
                xs={12}
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Button
                  variant="contained"
                  fullWidth
                  sx={{
                    height: "40px",
                    backgroundColor: "#14008B",
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                  }}
                  endIcon={
                    <AddIcon sx={{ fontSize: "30px", fontWeight: 500 }} />
                  }
                  onClick={() => {
                    setOpen(true);
                  }}
                >
                  Add Appointment
                </Button>
              </Grid>
            </Grid>
          </Grid>
        )}

        <Grid xs={6} sx={{ display: "flex" }}></Grid>

        <Grid xs={12} mt={1}></Grid>

        <Grid item xs={12}>
          {businessChooseTab?.value === "Assigned" && (
            <Grid
              container
              sx={{
                backgroundColor: "white",
                borderTopLeftRadius: "10px",
                borderTopRightRadius: "10px",
              }}
            >
              <Grid
                item
                xs={12}
                p={0}
                sx={{ borderBottom: "1px solid #4E4E4E" }}
              >
                <Tabs
                  value={valuet}
                  onChange={handleChanget}
                  textColor="primary"
                  variant="fullWidth"
                >
                  <Tab
                    value="Assigned"
                    label="Assigned"
                    onClick={() => {
                      // paginationApiCall(date, pageNo, "null", "paid");
                    }}
                    sx={{
                      fontWeight: valuet === "Assigned" ? "700" : "",
                      fontSize: { xs: "12px", sm: "13px", md: "16px" },
                      border:
                        valuet === "Assigned"
                          ? `2px solid ${theme.palette.primary.main}`
                          : "",
                      flexGrow: 1,
                      borderRadius: "5px",
                    }}
                  />

                  <Tab
                    value="Completed"
                    label="Completed"
                    onClick={() => {
                      // setPaidBills("");
                      // paginationApiCall(date, pageNo, "null");
                    }}
                    sx={{
                      fontWeight: valuet === "Completed" ? "700" : "",
                      fontSize: { xs: "12px", sm: "13px", md: "16px" },
                      border:
                        valuet === "Completed"
                          ? `2px solid ${theme.palette.primary.main}`
                          : "",
                      flexGrow: 1,
                      borderRadius: "5px",
                    }}
                  />

                  <Tab
                    value="Cancelled"
                    label="Cancelled"
                    onClick={() => {
                      // paginationApiCall(date, pageNo, "null", "paid");
                    }}
                    sx={{
                      fontWeight: valuet === "Cancelled" ? "700" : "",
                      fontSize: { xs: "12px", sm: "13px", md: "16px" },
                      border:
                        valuet === "Cancelled"
                          ? `2px solid ${theme.palette.primary.main}`
                          : "",
                      flexGrow: 1,
                      borderRadius: "5px",
                    }}
                  />
                </Tabs>
              </Grid>
              <Grid item xs={6} sx={{ padding: "10px 15px" }} mt={1}>
                <Box
                  readonly
                  fullWidth
                  onClick={() => {
                    aetOpenT(true);
                  }}
                  sx={{
                    display: "flex",
                    height: "22px",
                    alignItems: "center",
                    justifyContent: "space-between",
                    width: "100%",
                    border: "2px solid #5857b3",
                    p: 1,
                    borderRadius: "4px ",
                    color: "grey",
                    "&:hover": {
                      cursor: "pointer !important",
                    },
                  }}
                  onChange={(e) => {
                    // setSearch(e.target.value);
                  }}
                >
                  <Typography
                    variant="p"
                    fontSize={{ xs: "12px", sm: "13px", md: "18px" }}
                  >
                    {search !== "" ? search : "Search by Name/Mobile Number"}
                  </Typography>
                  <SearchIcon
                    onClick={() => {
                      setSearchOutStandingsModal(true);
                    }}
                    sx={{
                      color: (theme) => theme.palette.primary.main,
                      cursor: "pointer",
                    }}
                  />
                </Box>
              </Grid>
              <Grid item xs={6} sx={{ padding: "10px 15px" }} mt={1}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    value={selectedDate ? dayjs(selectedDate) : null}
                    onChange={(newValue) => {
                      setSelectedDate(newValue);
                    }}
                    format="DD-MMM-YYYY"
                    slots={{ openPickerIcon: CalendarMonthIcon }}
                    slotProps={{
                      textField: {
                        fullWidth: true,
                        size: "small",
                        label: "Date",
                        InputProps: {
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton edge="end">
                                <Box
                                  component="img"
                                  src={calendar}
                                  alt="calendar icon"
                                  sx={{
                                    width: 20,
                                    height: 20,
                                    cursor: "pointer",
                                  }}
                                />
                              </IconButton>
                            </InputAdornment>
                          ),
                          sx: { background: "#fff", borderRadius: 1 },
                        },
                      },
                      openPickerIcon: {
                        sx: { color: "#000" },
                      },
                    }}
                    InputProps={{
                      // endAdornment: (
                      //   <InputAdornment position="end">
                      //     <CalendarTodayIcon />
                      //   </InputAdornment>
                      // ),
                      sx: {
                        // background: "#fff",

                        fontSize: { xs: "12px", sm: "13px", md: "16px" },
                        // fontWeight: 500,
                      },
                    }}
                  />
                </LocalizationProvider>
              </Grid>
            </Grid>
          )}
          <Box
            container
            sx={{
              padding: { sm: "20px", xs: "10px" },
              backgroundColor: "white",
              borderTopLeftRadius: value === "Unassigned" ? "12px" : "0px",
              borderTopRightRadius: value === "Unassigned" ? "12px" : "0px",
              borderBottomLeftRadius: "12px",
              borderBottomRightRadius: "12px",
            }}
          >
            <Box
              container
              sx={{
                overflowX: "auto",
                overflowY: "auto",
              }}
            >
              <Box
                sx={{
                  minWidth: "900px",
                  width: "100%",
                  height: "70vh",
                  p: "10px",
                  background: "white",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    borderBottom: "1.5px solid black",
                    alignItems: "center",
                    minWidth: "100%",
                    width: "max-content",
                  }}
                >
                  <Box
                    sx={{
                      width: "120px",
                      px: { sm: "22px", xs: "1px" },
                      paddingBottom: "8px",
                      color: "#01008B",
                      fontWeight: 500,
                      fontSize: { xs: "12px", sm: "13px", md: "15px" },
                      marginLeft: "14px",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                    }}
                  >
                    Appointment Id
                  </Box>
                  <Box
                    sx={{
                      width: { xs: "150px", sm: "180px" },
                      color: "#01008B",
                      fontWeight: 500,
                      paddingBottom: "8px",
                      fontSize: { xs: "12px", sm: "13px", md: "15px" },
                      textAlign: "center",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                    }}
                  >
                    Customer Name
                  </Box>
                  <Box
                    sx={{
                      width: { xs: "100px", sm: "150px" },
                      color: "#01008B",
                      paddingBottom: "8px",
                      fontWeight: 500,
                      fontSize: { xs: "12px", sm: "13px", md: "15px" },
                      textAlign: "center",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                    }}
                  >
                    Book For
                  </Box>
                  <Box
                    sx={{
                      width: { xs: "120px", sm: "150px" },

                      color: "#01008B",
                      paddingBottom: "8px",
                      fontWeight: 500,
                      fontSize: { xs: "12px", sm: "13px", md: "15px" },
                      textAlign: "center",
                      overflow: "hidden",
                      // textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                      marginLeft: "30px",
                    }}
                  >
                    Customer Number
                  </Box>
                  <Box
                    sx={{
                      width: "250px",
                      color: "#01008B",
                      fontWeight: 500,
                      paddingBottom: "8px",
                      fontSize: { xs: "12px", sm: "13px", md: "15px" },
                      textAlign: "center",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                      // marginLeft:"20px"
                    }}
                  >
                    Services
                  </Box>
                  <Box
                    sx={{
                      width: "170px",
                      color: "#01008B",
                      fontWeight: 500,
                      fontSize: { xs: "12px", sm: "13px", md: "15px" },
                      paddingBottom: "8px",
                      textAlign: "center",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                      marginLeft: "24px",
                      pl: 2,
                    }}
                  >
                    Date and Time
                  </Box>
                  {/* <Box
                  sx={{
                    width: "200px",
                    color: "#01008B",
                    fontWeight: 500,
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    paddingBottom: "8px",
                    textAlign: "center",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                  }}
                >
                  Assigned To
                </Box> */}
                  {(valuet === "Assigned" || value === "Unassigned") && (
                    <Box
                      sx={{
                        width: value === "Unassigned" ? "140px" : "320px",
                        color: "#01008B",
                        fontWeight: 500,
                        paddingBottom: "8px",
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        textAlign: "center",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        paddingLeft: value === "Unassigned" ? "30px" : "0px",
                      }}
                    >
                      Actions
                    </Box>
                  )}
                </Box>
                {/* Data Rows */}
                <Box sx={{ marginTop: "10px" }}>
                  {data?.map((item, i) => {
                    if (item?.status === valuet && value !== "Unassigned") {
                      return (
                        <AppointmentDashboardCard
                          value={value}
                          valuet={valuet}
                          item={item}
                          key={"anualCard" + i}
                          onClick={(data) => {
                            console.log("item ", data);
                            console.log("clicked data", data);

                            setOpen(true);
                            setSelectedCustomer(data);
                          }}
                          callback={(data) => {
                            let payload = { ...item };
                            console.log("Completed = ", {
                              ...payload,
                              status: "Completed",
                            });
                            if (data.api == "complete") {
                              UpdatedCustomerAppointment(
                                { ...payload, status: "Completed" },
                                async (re) => {
                                  getAllAppoint(
                                    { page: 1, pageSize: 1000 },
                                    (res) => {
                                      console.log("getAllAppoint", res);
                                      setData(res?.list);
                                    }
                                  );
                                }
                              );
                            }
                            if (data.api == "cancel") {
                              // UpdatedCustomerAppointment( {...item,status:"Cancelled"} ,   async(re)=>{
                              //   getAllAppoint({ page: 1, pageSize: 1000 }, (res) => {
                              //     console.log("getAllAppoint", res);
                              //     setData(res?.list);
                              //   });
                              // })
                            }
                          }}
                        />
                      );
                    }
                    if (value === "Unassigned") {
                      return (
                        <AppointmentDashboardCard
                          value={value}
                          valuet={valuet}
                          item={item}
                          key={"anualCard" + i}
                          onClick={(data) => {
                            console.log("item ", data);
                            console.log("clicked data", data);

                            setOpen(true);
                            setSelectedCustomer(data);
                          }}
                          callback={(data) => {
                            console.log("Completed = ", {
                              ...item,
                              status: "Completed",
                            });
                            let payload = { ...item };
                            if (data.api == "complete") {
                              UpdatedCustomerAppointment(
                                { ...payload, status: "Completed" },
                                async (re) => {
                                  getAllAppoint(
                                    { page: 1, pageSize: 1000 },
                                    (res) => {
                                      console.log("getAllAppoint", res);
                                      setData(res?.list);
                                      setOpen(false);
                                    }
                                  );
                                }
                              );
                            }
                            if (data.api == "cancel") {
                              UpdatedCustomerAppointment(
                                { ...payload, status: "Cancelled" },
                                async (re) => {
                                  getAllAppoint(
                                    { page: 1, pageSize: 1000 },
                                    (res) => {
                                      console.log("getAllAppoint", res);
                                      setData(res?.list);
                                      setOpen(false);
                                    }
                                  );
                                }
                              );
                            }
                          }}
                        />
                      );
                    }
                  })}
                </Box>
              </Box>
            </Box>
          </Box>
        </Grid>

        <Appoinmentadle
          open={open}
          setOpen={setOpen}
          selectedCustomer={selectedCustomer}
          apiCallback={() => {
            getAllAppoint({ page: 1, pageSize: 1000 }, (res) => {
              console.log("getAllAppoint", res);
              setData(res?.list);
            });
          }}
        />
        {/* <DisplayAnnualRecharge open={open} setOpen={setOpen} /> */}
        {/* <Pagination
    count={pagination.total}
    page={pagination.page}
    onChange={(event,value)=>{
      setPagination({
        ...pagination,
        page: value,
      });
    }}
  /> */}
        <EmployeeModal
          // modalData={modalData}
          callback={(data) => {
            setSearch(data?.name);
            aetOpenT(false);
          }}
          open={openT}
          setOpen={aetOpenT}
        />
        <CalenderModal
          setValuet={setValuet}
          data={data}
          open={openCalender}
          setOpen={setOpenCalender}
          setSelectedDate={setSelectedDate}
          selectedDate={selectedDate}
        />
      </Grid>
    </>
  );
}
